<template>
  <div>
    <compWrapper title="基本信息"
                 theme="primary">
      <compFormQuery v-if="type==='query'"
                     class="margin-top-15"
                     :labelWidth="150"
                     :formdata="getBase"
                     :value="formData"></compFormQuery>
      <compFormEdit v-else
                    ref="formbase"
                    class="margin-top-15"
                    :labelWidth="150"
                    :formdata="getBase"
                    v-model="formData"></compFormEdit>
    </compWrapper>
    <!-- <compLog v-if="type==='query'" wrapper :data="logList"></compLog> -->
    <div v-if="type!='query'"
         class="text-right margin-top-10">
      <vButton theme="primary"
               @click="submit">保存</vButton>
      <vButton class="margin-left-10"
               @click="onCancel">返回</vButton>
    </div>
    <vLoading size="large"
              transfer
              :loading="loading"></vLoading>
  </div>
</template>

<script>
import { HttpQueryDeliveryWayOne, HttpSaveDeliveryWayOne, HttpAllInsuranceServiceList } from '@/service/credit';
import { HttpInboundOrderLogList } from "@/service/inbound";
import { mapGetters } from "vuex";
export default {
  props: ['querytype', 'activeid'],
  components: {
    compFormEdit: () => import("@components/templates/formedit"),
    compWrapper: () => import("@components/templates/wrapper"),
    compFormQuery: () => import("@components/templates/formquery"),
    compLog: () => import("@components/templates/log")
  },
  data () {
    return {
      type: this.querytype || this.$route.params.type,
      id: this.activeid || this.$route.query.id,
      logList: [],
      loading: false,
      formData: {
      },
      insuranceServiceList: [],
    };
  },
  created () {
    this.getDetail();
    // if(this.type == 'query'){
    //     // 请求日志的接口
    //     HttpInboundOrderLogList({ 'search[EQ_orderType]': 9003, 'search[EQ_orderId]': this.id }).then(res => {
    // 		this.logList = res.data;
    // 	}).catch(err => {
    // 		this.loading = false;
    // 		this.$Message.error(err.message);
    // 	})
    // }
    HttpAllInsuranceServiceList().then(res => {
      this.insuranceServiceList = res.data.filter(item => {
        return item.status == 0
      })
    })
  },
  computed: {
    ...mapGetters('dictionary', ['getInsuranceList']),
    insuranceList () {
      return this.getInsuranceList.filter(item => {
        return item.attach.status === 0
      })
    },
    getBase () {
      return [
        {
          label: "保险产品",
          key: "serviceId",
          tag: "vSelect",
          options: this.insuranceList,
          query: this.type != 'add'
        },
        {
          label: "保险服务商",
          key: "serviceProviderId",
          tag: "vSelect",
          options: this.insuranceServiceList.map(item => {
            return {
              value: item.id,
              label: item.providerName + '(' + item.providerCode + ')',
            }
          }),
          query: this.type != 'add'
        },
        {
          label: "系统承运商",
          key: 'carrierCode',
          tag: 'vSelect',
          options: [
            { value: 'FedEx', label: 'FedEx' },
            { value: 'UPS', label: 'UPS' },
            { value: 'LTL', label: 'LTL' },
          ],
          query: this.type != 'add'
        },
        {
          label: "运输方式",
          key: 'insuranceTransportType',
          tag: 'vSelect',
          options: [
            { value: '0', label: "快递" },
            { value: '1', label: "卡车" },
          ],
          query: this.type != 'add'
        },
        {
          label: "保险运输方式编码",
          key: "insuranceTransportCode",
          tag: "vInput",
        },
      ];
    },
  },
  methods: {
    onCancel () {
      this.$router.push({
        name: "rulesDeliverywayList"
      });
    },
    cancel () {
      this.$emit('on-close')
    },
    getDetail () {
      if (this.type === "add") return;
      this.loading = true;
      HttpQueryDeliveryWayOne({
        id: this.id,
      }).then(res => {
        const data = res.data || {};
        this.formData = data;
        this.loading = false;
      }, err => {
        this.loading = false;
        this.$VMessage.error(err.message);
      });
    },
    async submit () {
      const valid = await this.$refs.formbase.validate();
      if (!valid) return;
      this.loading = true;
      HttpSaveDeliveryWayOne({
        id: this.id,
        orgId: global.SYSID,
        ...this.formData,
      }).then(res => {
        this.loading = false;
        this.onCancel();
      }, err => {
        this.loading = false;
        this.$VMessage.error(err.message);
      })
    },
  }
};
</script>
